import { Component, OnInit } from "@angular/core";
import { AdfiService } from "@services/adfi-service";
import { Filter } from "../util/Filter";
import { AdfiGraphqlService } from "@services/adfi-graphql.service";
import { AdfiGrowlService } from "@services/adfi-growl.service";
import { PeriodState } from "@Interfaces/index";

export type AlertType = "info" | "success" | "warning" | "error";

export interface AlertItem {
    type?: AlertType;
    message: string;
    icon?: string;
}

interface PendingRequest {
    name: string;
    module: string;
    entity: string;
    informativeMessage: boolean;
}

@Component({
    selector: "app-alerts",
    templateUrl: "./alerts.component.html",
    styleUrls: ["./alerts.component.scss"],
})
export class AlertsComponent implements OnInit {
    canView: boolean;
    alerts: AlertItem[] = [];

    constructor(
        private adfiService: AdfiService,
        private graphqlService: AdfiGraphqlService,
        private adfiGrowlService: AdfiGrowlService
    ) {
        this.canView = this.adfiService.validPermission("Alerts", "viewPpyeAlert", PeriodState.NO_STATUS);
    }

    ngOnInit(): void {
        if (this.canView) {
            this.adfiService
                .get("/api/get/pending-requests")
                .subscribe((data: any) => {
                    if (data && Array.isArray(data)) {
                        data.forEach((alert) => {
                            const pendingRequest = {
                                name: alert.name,
                                entity: alert.entity,
                                module: alert.module,
                                messageEmpty: alert.messageEmpty,
                                informativeMessage: alert.informativeMessage,
                                list: [],
                            };
                            this.loadListPending(
                                pendingRequest,
                                alert.keyIdentifier,
                                alert.keysDescription,
                                alert.keysValue,
                                alert.filters
                            );
                        });
                    }
                });
        }
    }

    private async loadListPending(
        request: PendingRequest,
        keyIdentifier: string = "consecutive",
        keysDescription: string[],
        keyValue: string[],
        filters
    ) {
        await this.getRequest(
            request,
            `id ${keyIdentifier} ${keysDescription.join(" ")} ${keyValue.join(" ")}`,
            filters,
            (data) => {
                this.alerts = data.map((item) => ({
                    type: this.validateTimeout(item.value),
                    message: item.data,
                }));
            }
        );
    }

    private async getRequest(
        request: PendingRequest,
        columns: string,
        filters,
        next: (data: any, config: Filter) => void
    ) {
        const error = (err: any) => {
            this.adfiGrowlService.errorMessage(
                err,
                "Error al obtener la información del Sistema"
            );
        };
        const f = new Filter(this.adfiService);
        f.entityName = request.entity;
        f.module = request.module;
        f.defaultQuery = filters;
        f.loadedConfig.subscribe(async () => {
            const params: any = f.generateFilters();
            const count = await this.graphqlService.countEntity(
                f.configTable.plural,
                params
            );
            this.graphqlService.getEntity(
                f.configTable.plural,
                columns,
                count,
                params,
                {
                    next: (data) => {
                        next(data, f);
                    },
                    error,
                }
            );
        });
        f.loadConfig();
    }

    validateTimeout(days: number): string {
        if (days < 5) {
            return "success";
        } else if (days >= 5 && days < 8) {
            return "warning";
        } else {
            return "error";
        }
    }
}
